import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {
  isLoading: false,
  error: null,
  products: [],
  isProductLoading: false,
  singleproducts: null,
  issingleLoading: false,
  activeproducts: [],
  isActiveLoading: false,
  relatedproducts: [],
  isRelatedLoading: false,
  isSearchLoading: false,
  searchproducts: [],
  cart: [],
  cartCount: 0,
  wishlistCount: 0,
};

export const getActiveProducts = createAsyncThunk(
  "get_active_product_page",
  async (
    { categoryname, bestseller, newarrivals, page = 1, limit = 10 },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(getActiveProductsStart());

      const response = await axios.get(
        `/products/get_active_products.php?category_name=${
          categoryname || ""
        }&bestseller=${bestseller || ""}&newarrival=${
          newarrivals || ""
        }&page=${page}&limit=${limit}&sort=${"price-low"}`
      );

      if (response?.data?.status === "success") {
        dispatch(
          getActiveProductsSuccess({
            products: response.data.products,
            total: response.data.total, // 👈 total count from backend
            page,
          })
        );
      }

      return response.data;
    } catch (error) {
      dispatch(
        getActiveProductsFailure(
          error?.response?.data?.message || "Something went wrong"
        )
      );
      return rejectWithValue(error);
    }
  }
);

export const getNewArrivalsProducts = createAsyncThunk(
  "get_active_product_page",
  async ({ newarrival }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/products/get_new_arrivals.php?newarrival=${newarrival || ""}`
      );

      return response.data;
    } catch (error) {
      return error.response.data.message;
    }
  }
);
export const getBestSellProducts = createAsyncThunk(
  "get_active_product_page",
  async ({ bestseller }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/products/get_new_arrivals.php?bestseller=${bestseller || ""}`
      );

      return response.data;
    } catch (error) {
      return error.response.data.message;
    }
  }
);
export const getRelatedActiveProducts = createAsyncThunk(
  "get_related_active_product_page",
  async ({ category, excludeId }, { dispatch, rejectWithValue }) => {
    const filters = { category, excludeId };

    // Build query string dynamically (skip null/empty/0)
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== "" && value !== 0) {
        queryParams.append(key, value);
      }
    });

    try {
      dispatch(getRelatedProductsStart());
      const response = await axios.get(
        `/products/get_related_products.php?${queryParams.toString()}`
      );
      if (response?.data?.status == "success") {
        dispatch(getRelatedProductsSuccess(response?.data?.data));
      }

      return response.data;
    } catch (error) {
      dispatch(getRelatedProductsFailure(error.response.data.message));
    }
  }
);
export const getSingleProduct = createAsyncThunk(
  "get_product_page",
  async (slug, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getSingleProductsStart());
      const response = await axios.get(
        `products/get_productwithslug.php?slug=${slug}`
      );
      if (response?.data?.status == "success") {
        dispatch(getSingleProductsSuccess(response?.data?.data));
      }
      return response.data;
    } catch (error) {
      dispatch(getSingleProductsFailure(error.response.data.message));
    }
  }
);

export const getSearchProducts = createAsyncThunk(
  "products_search",
  async (search, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getSearchProductsStart());
      const response = await axios.get(
        `/products/search_products.php?search=${search}`
      );
      if (response?.data?.status == "success") {
        dispatch(getSearchProductsSuccess(response?.data?.products));
      }
    } catch (error) {
      dispatch(getSearchProductsFailure(error.response.data.message));
    }
  }
);

export const getProductInventory = createAsyncThunk(
  "inventories/get_inventory_for_product",
  async (
    { product_id, size_id, color_id, qty },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(getallproductInventoryStart());
      const response = await axios.get(
        `inventories/get_inventory_for_product.php?product_id=${product_id}&size_id=${
          size_id || ""
        }&color_id=${color_id || ""}&qty=${qty || 1}`
      );
      dispatch(getallproductInventorySuccess(response?.data));
      return response?.data;
    } catch (error) {
      dispatch(getallproductInventoryfailure(error.response.data.message));
      return rejectWithValue(error.response.data.message);
    }
  }
);
export const getInventoryById = createAsyncThunk(
  "inventories/get_inventory_by_id",
  async ({ inventory_id, qty }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getproductInventoryStart());
      const response = await axios.get(
        `inventories/get_inventory_by_id.php?inventory_id=${inventory_id}&qty=${qty}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      if (response?.data?.status == "success") {
        dispatch(getproductInventorySuccess(response?.data));
      }
      return response?.data;
    } catch (error) {
      dispatch(getproductInventoryfailure(error.response.data.message));
      return rejectWithValue(error.response.data.message);
    }
  }
);
export const getProductSizes = createAsyncThunk(
  "sizes/get_sizes_by_ids",
  async ({ productId, sizes }, { rejectWithValue }) => {
    try {
      const response = await axios.post("sizes/get_sizes_by_ids.php", {
        productId,
        sizes, // should be an array like ["1","2","3"]
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);
export const getProductColors = createAsyncThunk(
  "colors/get_colors_by_ids",
  async ({ productId, colors }, { rejectWithValue }) => {
    try {
      const response = await axios.post("colors/get_colors_by_ids.php", {
        productId,
        colors, // should be an array like ["1","2","3"]
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const addTocart = createAsyncThunk(
  "cart",
  async (cartData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`cart/add_to_cart.php`, cartData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);
export const addToWishlist = createAsyncThunk(
  "wishlist",
  async (wishlistData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        `wishlist/add_to_wishlist.php`,
        wishlistData,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const getCartData = createAsyncThunk(
  "cart/get_cart",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getCartDataStart());
      const response = await axios.get(`cart/get_cart.php`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      dispatch(getCartDataSuccess(response?.data));
      return response?.data;
    } catch (error) {
      dispatch(getCartDataFailure(error.response.data.message));
      return rejectWithValue(error.response.data.message);
    }
  }
);
export const getCartWishlistLength = createAsyncThunk(
  "cart/get_cart_wishlist_count",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getCartCountStart());
      const response = await axios.get(`cart/get_cart_wishlist_count.php`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      dispatch(getCartCountSuccess(response?.data));

      return response?.data;
    } catch (error) {
      dispatch(getCartCountFailure(error.response.data.message));

      return rejectWithValue(error.response.data.message);
    }
  }
);
export const removeCartData = createAsyncThunk(
  "cart/remove_cart",
  async ({ inventory_id }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getCartDataStart());
      const response = await axios.post(
        `cart/remove_from_cart.php`,
        {
          inventory_id,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);
export const updateCartQuantity = createAsyncThunk(
  "cart/update_cart_quantity",
  async ({ inventory_id, quantity }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        `cart/update_cart_quantity.php`,
        {
          inventory_id,
          quantity,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);
export const getWishlistData = createAsyncThunk(
  "wishlist/get_wishlist",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getWishlistDataStart());
      const response = await axios.get(`wishlist/get_wishlist.php`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      dispatch(getWishlistDataSuccess(response?.data));
      return response?.data;
    } catch (error) {
      dispatch(getWishlistDataFailure(error.response.data.message));
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const fetchGuestCart = createAsyncThunk(
  "products/fetchGuestCart",
  async (items, thunkAPI) => {
    try {
      const res = await axios.post("/cart/guest_cart.php", {
        items, // [{ inventory_id, quantity }]
      });
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    getActiveProductsStart(state) {
      state.isActiveLoading = true;
      state.error = null;
    },

    getActiveProductsSuccess(state, action) {
      const { products, page, total } = action.payload;

      // 🔥 Page 1 = reset, Load More = append
      if (page === 1) {
        state.activeproducts = products;
      } else {
        state.activeproducts = [...state.activeproducts, ...products];
      }

      state.totalProducts = total;
      state.isActiveLoading = false;
    },

    getActiveProductsFailure(state, action) {
      state.isActiveLoading = false;
      state.error = action.payload;
    },
    getRelatedProductsStart(state) {
      state.isRelatedLoading = true;
      state.error = null;
    },
    getRelatedProductsSuccess(state, action) {
      state.relatedproducts = action.payload;
      state.isRelatedLoading = false;
    },
    getRelatedProductsFailure(state, action) {
      state.relatedproducts = null;
      state.isRelatedLoading = false;
      state.error = action.payload;
    },
    getSingleProductsStart(state) {
      state.issingleLoading = true;
      state.error = null;
    },
    getSingleProductsSuccess(state, action) {
      state.singleproducts = action.payload;
      state.issingleLoading = false;
    },
    getSingleProductsFailure(state, action) {
      state.singleproducts = null;
      state.issingleLoading = false;
      state.error = action.payload;
    },

    getSearchProductsStart(state) {
      state.isSearchLoading = true;
      state.error = null;
    },
    getSearchProductsSuccess(state, action) {
      state.searchproducts = action.payload;
      state.isSearchLoading = false;
    },
    getSearchProductsFailure(state, action) {
      state.searchproducts = null;
      state.isSearchLoading = false;
      state.error = action.payload;
    },
    getallproductInventoryStart(state) {
      state.isInventoryLoading = true;
      state.error = null;
      state.productInventoryList = [];
    },
    getallproductInventorySuccess(state, action) {
      state.isInventoryLoading = false;
      state.productInventoryList = action.payload;
    },
    getallproductInventoryfailure(state, action) {
      state.error = action.payload;
      state.isInventoryLoading = false;
    },
    getproductInventoryStart(state) {
      state.isInventoryLoading = true;
      state.error = null;
      state.productInventory = null;
    },
    getproductInventorySuccess(state, action) {
      state.isInventoryLoading = false;
      state.productInventory = action.payload;
    },
    getproductInventoryfailure(state, action) {
      state.error = action.payload;
      state.isInventoryLoading = false;
    },
    getCartDataStart(state, action) {
      state.cartLoading = true;
      state.carterror = null;
      state.cart = [];
    },
    getCartDataSuccess(state, action) {
      state.cartLoading = false;
      state.cart = action.payload;
    },
    getCartDataFailure(state, action) {
      state.carterror = action.payload;
      state.cartLoading = false;
    },
    getWishlistDataStart(state, action) {
      state.wishlistLoading = true;
      state.wishlisterror = null;
      state.wishlist = [];
    },
    getWishlistDataSuccess(state, action) {
      state.wishlistLoading = false;
      state.wishlist = action.payload?.wishlist;
    },
    getWishlistDataFailure(state, action) {
      state.wishlisterror = action.payload;
      state.wishlistLoading = false;
    },
    getCartCountStart(state, action) {
      state.cartCount = 0;
      state.wishlistCount = 0;
    },
    getCartCountSuccess(state, action) {
      state.cartCount = action.payload.cart_length;
      state.wishlistCount = action.payload.wishlist_length;
    },
    getCartCountFailure(state, action) {
      state.cartCount = 0;
      state.wishlistCount = 0;
    },
  },
});

export const {
  getCartCountStart,
  getCartCountSuccess,
  getCartCountFailure,
  getActiveProductsSuccess,
  getActiveProductsStart,
  getActiveProductsFailure,
  getRelatedProductsSuccess,
  getRelatedProductsStart,
  getRelatedProductsFailure,
  getSingleProductsSuccess,
  getSingleProductsStart,
  getSingleProductsFailure,
  getSearchProductsSuccess,
  getSearchProductsStart,
  getSearchProductsFailure,
  getallproductInventoryStart,
  getallproductInventorySuccess,
  getproductInventoryfailure,
  getproductInventoryStart,
  getproductInventorySuccess,
  getallproductInventoryfailure,
  getCartDataStart,
  getCartDataSuccess,
  getCartDataFailure,
  getWishlistDataStart,
  getWishlistDataSuccess,
  getWishlistDataFailure,
} = productsSlice.actions;

export default productsSlice.reducer;
